import React, { Component } from "react";
import { Table, Button, Form, Row, Col, Badge, Card, Spinner, ListGroup, Alert, Pagination } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { GET_LIBRARY_REPORT, GET_NEW_EDUCATIONAL_STUDENTS, GET_LIBRARY_FINES, GET_STUDENT_ACTIVE_LOANS } from "./queries";

class CheckboxDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.ref = React.createRef();
  }
  componentDidMount() { document.addEventListener("mousedown", this.handleOutside); }
  componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutside); }
  handleOutside = (e) => {
    if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false });
  };
  toggle = (id) => {
    const { value, onChange, options } = this.props;
    if (value.includes('__NONE__')) {
      onChange([id]);
      return;
    }
    if (value.length === 0) {
      onChange(options.map(o => o.value).filter(v => v !== id));
      return;
    }
    const newValue = value.includes(id) ? value.filter(v => v !== id) : [...value, id];
    if (newValue.length === 0) {
      onChange(['__NONE__']);
    } else if (newValue.length === options.length) {
      onChange([]);
    } else {
      onChange(newValue);
    }
  };

  render() {
    const { options, value, placeholder, onChange } = this.props;
    const { open } = this.state;
    
    const noneSelected = value.includes('__NONE__');
    const allSelected = !noneSelected && (value.length === 0 || (options.length > 0 && options.every(o => value.includes(o.value))));
    
    const label = (value.length === 0 || allSelected) ? placeholder
      : noneSelected ? "None selected"
        : value.length === 1 ? (options.find(o => o.value === value[0])?.label || `${value.length} selected`)
          : `${value.length} selected`;
          
    const isMuted = value.length === 0 || noneSelected;

    return (
      <div ref={this.ref} style={{ position: "relative" }}>
        <div onClick={() => this.setState({ open: !open })}
          style={{ borderRadius: 8, border: "1.5px solid #e2e8f0", padding: "8px 12px", fontSize: 12, color: isMuted ? "#94a3b8" : "#1e293b", background: "#fff", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none", height: 36 }}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
          <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 10, color: "#94a3b8", flexShrink: 0, marginLeft: 6 }} />
        </div>
        {open && (
          <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.08)", zIndex: 9999, maxHeight: 200, overflowY: "auto" }}>
            {options.length === 0 ? (
              <div style={{ padding: "8px 12px", fontSize: 11, color: "#94a3b8" }}>No options</div>
            ) : (
              <>
                <div onClick={() => onChange(allSelected ? ['__NONE__'] : [])}
                  style={{ padding: "8px 12px", fontSize: 11, fontWeight: 700, color: "#6366f1", cursor: "pointer", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", gap: 8 }}>
                  <input type="checkbox" readOnly checked={allSelected} style={{ accentColor: "#6366f1" }} />
                  Select All
                </div>
                {options.map(o => {
                  const isChecked = !noneSelected && (value.length === 0 || value.includes(o.value));
                  return (
                    <div key={o.value} onClick={() => this.toggle(o.value)}
                      style={{ padding: "7px 12px", fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, background: isChecked ? "#f5f3ff" : "transparent", borderBottom: "1px solid #f8fafc" }}>
                      <input type="checkbox" readOnly checked={isChecked} style={{ accentColor: "#6366f1" }} />
                      <span style={{ color: isChecked ? "#4f46e5" : "#334155", fontWeight: isChecked ? 600 : 400 }}>{o.label}</span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: "active_loans", // "active_loans", "overdue", "fine_collection", "popular"
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      reportData: [],
      loading: true,
      error: null,
      
      searchQuery: "",
      selectedClasses: [],
      selectedSections: [],

      // Pagination State for Activity Logs
      currentPage: 1,
      pageSize: 10,
 
      // New properties for Class & Student Dues perspective
      viewPerspective: "student", // "student" or "log"
      studentsList: [],
      loadingStudents: false,
      selectedStudent: null,
      selectedStudentLoans: [],
      selectedStudentFines: [],
      loadingStudentDetail: false,
      allFines: [],
      allActiveLoans: [],
 
      studentSearchQuery: "",
      filterStudentClasses: [],
      filterStudentSections: [],
    };
  }
 
  componentDidMount() {
    this.fetchReport();
    this.loadStudentsAndDues();
  }
 
  loadStudentsAndDues = async () => {
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institutionid") || Cookies.get("institute_id") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || "0");
 
    this.setState({ loadingStudents: true });
    
    // 1. Fetch Students
    let studentsList = [];
    try {
      const studentsData = await client.query({
        query: GET_NEW_EDUCATIONAL_STUDENTS,
        variables: { institution_id: instId, branch_id: String(branchId) },
        fetchPolicy: "cache-first",
      });
      studentsList = (studentsData.data.getNewEducationalStudents || []).map(s => ({
        id: parseInt(s.student_id),
        name: s.student_name,
        roll_no: s.roll_no || "",
        admission_no: s.admission_no || "",
        code: s.admission_no || s.roll_no || String(s.student_id),
        class_name: s.class_name || "N/A",
        section_name: s.section_name || "N/A",
      }));
    } catch (err) {
      console.warn("getNewEducationalStudents query failed in Reports:", err);
    }

    if (studentsList.length === 0) {
      studentsList = [
        { id: 101, name: "Aravind Swamy", roll_no: "CSE-23-01", admission_no: "ADM-2023-0101", code: "ADM-2023-0101", class_name: "B.Tech III Yr", section_name: "A" },
        { id: 102, name: "Priyanka Reddy", roll_no: "CSE-23-02", admission_no: "ADM-2023-0102", code: "ADM-2023-0102", class_name: "B.Tech III Yr", section_name: "A" },
        { id: 103, name: "Amit Sharma", roll_no: "ECE-23-45", admission_no: "ADM-2023-0103", code: "ADM-2023-0103", class_name: "B.Tech III Yr", section_name: "B" },
        { id: 104, name: "Sunita Deshmukh", roll_no: "ME-24-12", admission_no: "ADM-2024-0204", code: "ADM-2024-0204", class_name: "B.Tech II Yr", section_name: "A" },
        { id: 105, name: "Vijay Kumar", roll_no: "EEE-22-19", admission_no: "ADM-2022-0054", code: "ADM-2022-0054", class_name: "B.Tech IV Yr", section_name: "C" }
      ];
    }

    // 2. Fetch all fines to map balances
    let allFines = [];
    try {
      const finesData = await client.query({
        query: GET_LIBRARY_FINES,
        variables: { institute_id: instId, branch_id: branchId },
        fetchPolicy: "network-only",
      });
      allFines = finesData.data.getLibraryFines || [];
    } catch (err) {
      console.error("Error loading fines in Reports:", err);
    }

    // 3. Fetch all active checkouts
    let allActiveLoans = [];
    try {
      const activeLoansData = await client.query({
        query: GET_LIBRARY_REPORT,
        variables: {
          type: "active_loans",
          institute_id: instId,
          branch_id: branchId
        },
        fetchPolicy: "network-only"
      });
      allActiveLoans = activeLoansData.data.getLibraryReport || [];
    } catch (err) {
      console.error("Error loading active loans in Reports:", err);
    }

    this.setState({
      studentsList,
      allFines,
      allActiveLoans,
      loadingStudents: false
    });
  };

  handleStudentClick = async (student) => {
    const { client } = this.props;
    const instId = parseInt(Cookies.get("institutionid") || Cookies.get("institute_id") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || "0");

    this.setState({
      selectedStudent: student,
      loadingStudentDetail: true,
      selectedStudentLoans: [],
      selectedStudentFines: []
    });

    try {
      if (!student || !student.id || isNaN(student.id)) {
        this.setState({ loadingStudentDetail: false });
        return;
      }
      // 1. Fetch exact active loans for this student
      const loansRes = await client.query({
        query: GET_STUDENT_ACTIVE_LOANS,
        variables: {
          borrower_id: student.id,
          borrower_type: "Student",
          institute_id: instId,
          branch_id: branchId
        },
        fetchPolicy: "network-only"
      });

      // 2. Filter fines for this student
      const studentFines = this.state.allFines.filter(
        f => f.borrower_code === student.code || 
             f.borrower_code === student.roll_no || 
             f.borrower_code === student.admission_no || 
             f.borrower_name === student.name
      );

      this.setState({
        selectedStudentLoans: loansRes.data.getStudentActiveLoans || [],
        selectedStudentFines: studentFines,
        loadingStudentDetail: false
      });
    } catch (err) {
      console.error("Error fetching student detailed library records:", err);
      this.setState({ loadingStudentDetail: false });
    }
  };

  fetchReport = async () => {
    const { client } = this.props;
    const { reportType, startDate, endDate } = this.state;
    const instId = parseInt(Cookies.get("institutionid") || Cookies.get("institute_id") || "0");
    const branchId = parseInt(Cookies.get("branch_id") || "0");

    try {
      this.setState({ loading: true });
      const { data } = await client.query({
        query: GET_LIBRARY_REPORT,
        variables: {
          type: reportType,
          from: startDate,
          to: endDate,
          institute_id: instId,
          branch_id: branchId,
        },
        fetchPolicy: "network-only",
      });
      this.setState({ reportData: data.getLibraryReport || [], loading: false, error: null, currentPage: 1 });
    } catch (err) {
      console.error("Error generating library report:", err);
      this.setState({ error: err.message, loading: false });
    }
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value) || 10;
    this.setState({ pageSize: size, currentPage: 1 });
  };

  handleFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === "reportType") {
      this.setState({ [name]: value, searchQuery: "", selectedClasses: [], selectedSections: [], currentPage: 1 }, this.fetchReport);
    } else {
      this.setState({ [name]: value, currentPage: 1 });
    }
  };

  handleDateChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, currentPage: 1 }, this.fetchReport);
  };

  exportCSV = (filteredData) => {
    if (!filteredData || filteredData.length === 0) return;

    const headers = ["Date", "Type", "Description", "Borrower Name", "Class", "Section", "Amount (INR)"];
    const rows = filteredData.map((r) => [
      r.date,
      r.type,
      r.description,
      r.student_name,
      r.class_name || "N/A",
      r.section_name || "N/A",
      r.amount !== null ? r.amount : "",
    ]);

    const csvContent = [headers.join(","), ...rows.map(e => e.map(val => `"${String(val).replace(/"/g, '""')}"`).join(","))].join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `Library_Report_${this.state.reportType}_${new Date().toISOString().split("T")[0]}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  formatCurrency = (val) =>
    "₹" + parseFloat(val || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  render() {
    const { 
      reportType, startDate, endDate, reportData, loading, error, searchQuery, selectedClasses, selectedSections,
      viewPerspective, studentsList, loadingStudents, selectedStudent, selectedStudentLoans, selectedStudentFines, 
      loadingStudentDetail, allFines, allActiveLoans, studentSearchQuery, filterStudentClasses, filterStudentSections,
      currentPage, pageSize
    } = this.state;

    const reportOptions = [
      { key: "active_loans", label: "Active Issues" },
      { key: "overdue", label: "Overdue History" },
      { key: "fine_collection", label: "Fine Collections" },
      { key: "popular", label: "Most Borrowed Books" },
    ];

    // Client-side sub-filtering logic for Activity Logs
    const filteredReportData = reportData.filter(r => {
      const q = searchQuery.toLowerCase().trim();
      const matchesSearch = !q || 
        r.student_name.toLowerCase().includes(q) || 
        r.description.toLowerCase().includes(q) ||
        (r.class_name && r.class_name.toLowerCase().includes(q));
      
      const matchesClass = selectedClasses.length === 0 || selectedClasses.includes(r.class_name);
      const matchesSection = selectedSections.length === 0 || selectedSections.includes(r.section_name);
      
      return matchesSearch && matchesClass && matchesSection;
    });

    const totalCount = filteredReportData.length;
    const totalPages = Math.ceil(totalCount / pageSize) || 1;
    const paginatedReportData = filteredReportData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const pageItems = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let p = startPage; p <= endPage; p++) {
      pageItems.push(
        <Pagination.Item 
          key={p} 
          active={p === currentPage} 
          onClick={() => this.handlePageChange(p)}
        >
          {p}
        </Pagination.Item>
      );
    }

    const uniqueClassesOptions = [...new Set(reportData.map(r => r.class_name).filter(Boolean))].map(c => ({ value: c, label: c }));
    const uniqueSectionsOptions = [...new Set(reportData.map(r => r.section_name).filter(Boolean))].map(s => ({ value: s, label: s }));

    // Calculations for Student/Class Directory
    const studentClassesOptions = [...new Set(studentsList.map(s => s.class_name).filter(Boolean))].map(c => ({ value: c, label: c }));
    const studentSectionsOptions = [...new Set(studentsList.map(s => s.section_name).filter(Boolean))].map(s => ({ value: s, label: s }));

    const filteredStudents = studentsList.filter(s => {
      const q = studentSearchQuery.toLowerCase().trim();
      const matchesSearch = !q || 
        s.name.toLowerCase().includes(q) || 
        s.code.toLowerCase().includes(q) || 
        s.roll_no.toLowerCase().includes(q) ||
        s.admission_no.toLowerCase().includes(q);
      
      const matchesClass = filterStudentClasses.length === 0 || filterStudentClasses.includes(s.class_name);
      const matchesSection = filterStudentSections.length === 0 || filterStudentSections.includes(s.section_name);
      
      return matchesSearch && matchesClass && matchesSection;
    });

    return (
      <div>
        {/* Tab Toggle Bar */}
        <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
          <h4 style={{ fontWeight: 800, color: "#1e293b", margin: 0 }}>
            Library Reports & Dues
          </h4>
          <div style={{ background: "#f1f5f9", padding: 4, borderRadius: 8, display: "inline-flex" }}>
            <Button
              variant="link"
              onClick={() => this.setState({ viewPerspective: "student" })}
              style={{
                textDecoration: "none",
                color: viewPerspective === "student" ? "#0f172a" : "#64748b",
                background: viewPerspective === "student" ? "#fff" : "transparent",
                fontWeight: 700,
                fontSize: 13,
                padding: "6px 16px",
                borderRadius: 6,
                boxShadow: viewPerspective === "student" ? "0 1px 3px rgba(0,0,0,0.05)" : "none",
                border: "none",
                transition: "all 0.2s"
              }}
            >
              <i className="fal fa-user-graduate mr-2" /> Class & Student Dues
            </Button>
            <Button
              variant="link"
              onClick={() => this.setState({ viewPerspective: "log" })}
              style={{
                textDecoration: "none",
                color: viewPerspective === "log" ? "#0f172a" : "#64748b",
                background: viewPerspective === "log" ? "#fff" : "transparent",
                fontWeight: 700,
                fontSize: 13,
                padding: "6px 16px",
                borderRadius: 6,
                boxShadow: viewPerspective === "log" ? "0 1px 3px rgba(0,0,0,0.05)" : "none",
                border: "none",
                transition: "all 0.2s"
              }}
            >
              <i className="fal fa-list-alt mr-2" /> Activity Log Reports
            </Button>
          </div>
        </div>

        {viewPerspective === "student" ? (
          <div>
            {loadingStudents ? (
              <div className="text-center p-5 bg-white border rounded">
                <Spinner animation="border" variant="primary" className="mb-2" />
                <p className="text-muted mb-0">Loading school directory & dues...</p>
              </div>
            ) : (
              <Row>
                {/* Left Panel: Class & Student Directory */}
                <Col md={5} xl={4}>
                  <Card className="border shadow-sm mb-4">
                    <Card.Header className="bg-white py-3 border-bottom-0">
                      <h6 className="m-0 font-weight-bold text-dark" style={{ fontSize: 14 }}>
                        <i className="fal fa-users-class text-primary mr-2" /> Student Directory
                      </h6>
                    </Card.Header>
                    <Card.Body className="pt-0">
                      <Row className="g-2 mb-2">
                        <Col xs={6}>
                          <CheckboxDropdown
                            placeholder="All Classes"
                            options={studentClassesOptions}
                            value={filterStudentClasses}
                            onChange={(vals) => this.setState({ filterStudentClasses: vals })}
                          />
                        </Col>
                        <Col xs={6}>
                          <CheckboxDropdown
                            placeholder="All Sections"
                            options={studentSectionsOptions}
                            value={filterStudentSections}
                            onChange={(vals) => this.setState({ filterStudentSections: vals })}
                          />
                        </Col>
                      </Row>
                      
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Search student name or roll..."
                          value={studentSearchQuery}
                          onChange={(e) => this.setState({ studentSearchQuery: e.target.value })}
                          style={{ fontSize: 12, height: 36 }}
                        />
                      </Form.Group>

                      {filteredStudents.length === 0 ? (
                        <div className="text-center py-4 text-muted" style={{ fontSize: 12 }}>
                          No students found.
                        </div>
                      ) : (
                        <ListGroup 
                          style={{ 
                            maxHeight: "380px", 
                            overflowY: "auto", 
                            border: "1px solid #e2e8f0", 
                            borderRadius: 6 
                          }}
                        >
                          {filteredStudents.map(student => {
                            // Find active checkouts from allActiveLoans
                            const studentLoans = allActiveLoans.filter(
                              l => l.student_name === student.name
                            );
                            // Find pending fines
                            const studentFines = allFines.filter(
                              f => (f.borrower_code === student.code || f.borrower_name === student.name) && f.balance_amount > 0
                            );
                            const unpaidFineSum = studentFines.reduce((sum, f) => sum + f.balance_amount, 0);

                            const isSelected = selectedStudent && selectedStudent.id === student.id;

                            return (
                              <ListGroup.Item
                                key={student.id}
                                onClick={() => this.handleStudentClick(student)}
                                style={{
                                  cursor: "pointer",
                                  borderLeft: isSelected ? "4px solid #3b82f6" : "none",
                                  backgroundColor: isSelected ? "#eff6ff" : "#fff",
                                  color: "#1e293b",
                                  borderBottom: "1px solid #f1f5f9",
                                  padding: "10px 14px",
                                  transition: "all 0.15s"
                                }}
                                className="d-flex flex-column gap-1"
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <span style={{ fontWeight: 700, fontSize: 13 }}>
                                    {student.name}
                                  </span>
                                  <div>
                                    {studentLoans.length > 0 && (
                                      <Badge variant="warning" className="mr-1" style={{ fontSize: 10 }}>
                                        {studentLoans.length} Issued
                                      </Badge>
                                    )}
                                    {unpaidFineSum > 0 && (
                                      <Badge variant="danger" className="mr-1" style={{ fontSize: 10 }}>
                                        ₹{unpaidFineSum.toFixed(0)}
                                      </Badge>
                                    )}
                                    {studentLoans.length === 0 && unpaidFineSum === 0 && (
                                      <Badge variant="success" style={{ fontSize: 10, background: "#10b981" }}>
                                        ✅ No Dues
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex justify-content-between text-muted" style={{ fontSize: 11 }}>
                                  <span>{student.class_name} ({student.section_name})</span>
                                  <span>{student.roll_no || student.admission_no}</span>
                                </div>
                              </ListGroup.Item>
                            );
                          })}
                        </ListGroup>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                {/* Right Panel: Detailed Profile, checkouts, outstanding dues */}
                <Col md={7} xl={8}>
                  {!selectedStudent ? (
                    <Card className="border shadow-sm h-100 d-flex align-items-center justify-content-center text-center p-5 bg-white" style={{ minHeight: 400 }}>
                      <div>
                        <i className="fal fa-address-card fa-4x text-light mb-3" />
                        <h5 className="font-weight-bold text-dark mb-1">Select Student Profile</h5>
                        <p className="text-muted" style={{ fontSize: 13, maxWidth: 320 }}>
                          Select a student from the class directory on the left to check active library checkouts, return logs, or dues clearance.
                        </p>
                      </div>
                    </Card>
                  ) : (
                    <Card className="border shadow-sm bg-white">
                      <Card.Body className="p-4">
                        {/* Student profile header card */}
                        <div className="d-flex justify-content-between align-items-start border-bottom pb-3 mb-4">
                          <div>
                            <h5 className="font-weight-bold text-dark mb-1">{selectedStudent.name}</h5>
                            <div className="text-muted" style={{ fontSize: 12 }}>
                              <span className="mr-3">
                                <strong>Class:</strong> {selectedStudent.class_name} ({selectedStudent.section_name})
                              </span>
                              <span className="mr-3">
                                <strong>Roll No:</strong> {selectedStudent.roll_no || "N/A"}
                              </span>
                              <span>
                                <strong>Admission No:</strong> {selectedStudent.admission_no}
                              </span>
                            </div>
                          </div>
                          <div>
                            {loadingStudentDetail ? (
                              <Spinner animation="border" size="sm" variant="primary" />
                            ) : (
                              (() => {
                                const totalUnpaidFine = selectedStudentFines.reduce((sum, f) => sum + f.balance_amount, 0);
                                const hasDues = selectedStudentLoans.length > 0 || totalUnpaidFine > 0;
                                return hasDues ? (
                                  <Badge 
                                    variant="danger" 
                                    style={{ 
                                      fontSize: 12, 
                                      padding: "8px 12px", 
                                      borderRadius: 20, 
                                      background: "#fef2f2", 
                                      color: "#ef4444", 
                                      border: "1px solid #fee2e2" 
                                    }}
                                  >
                                    <i className="fal fa-exclamation-circle mr-1" /> Dues Outstanding
                                  </Badge>
                                ) : (
                                  <Badge 
                                    variant="success" 
                                    style={{ 
                                      fontSize: 12, 
                                      padding: "8px 12px", 
                                      borderRadius: 20, 
                                      background: "#f0fdf4", 
                                      color: "#16a34a", 
                                      border: "1px solid #dcfce7" 
                                    }}
                                  >
                                    <i className="fal fa-check-circle mr-1" /> CLEAR: NO DUES PENDING
                                  </Badge>
                                );
                              })()
                            )}
                          </div>
                        </div>

                        {loadingStudentDetail ? (
                          <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="text-muted mt-2" style={{ fontSize: 13 }}>Fetching active checkout records...</p>
                          </div>
                        ) : (
                          <div>
                            {/* Section 1: Active issues / loans */}
                            <h6 className="font-weight-bold mb-3 text-dark d-flex align-items-center">
                              <i className="fal fa-book-open text-primary mr-2" /> Active Issues & Checked Out Books
                            </h6>
                            {selectedStudentLoans.length === 0 ? (
                              <Alert variant="success" className="d-flex align-items-center p-3 mb-4">
                                <i className="fal fa-info-circle fa-lg mr-3 text-success" />
                                <div style={{ fontSize: 13 }}>
                                  <strong>No active issues or returns pending.</strong> (All books returned)
                                </div>
                              </Alert>
                            ) : (
                              <div className="border rounded mb-4 overflow-hidden shadow-xs">
                                <Table responsive hover className="mb-0" style={{ fontSize: 12 }}>
                                  <thead style={{ background: "#f8fafc" }}>
                                    <tr>
                                      <th className="py-2 px-3">Book Title</th>
                                      <th className="py-2">Accession No</th>
                                      <th className="py-2">Issue Date</th>
                                      <th className="py-2">Due Date</th>
                                      <th className="py-2 text-center">Overdue Days</th>
                                      <th className="py-2 text-right">Fine Accrued</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedStudentLoans.map(loan => (
                                      <tr key={loan.id}>
                                        <td className="py-3 px-3 font-weight-bold text-dark">{loan.book_title}</td>
                                        <td className="py-3">{loan.accession_no}</td>
                                        <td className="py-3">{loan.issue_date}</td>
                                        <td className="py-3">
                                          <span style={{ color: new Date(loan.due_date) < new Date() ? "#ef4444" : "#1e293b", fontWeight: new Date(loan.due_date) < new Date() ? 700 : 400 }}>
                                            {loan.due_date}
                                          </span>
                                        </td>
                                        <td className="py-3 text-center">
                                          {loan.overdue_days > 0 ? (
                                            <Badge variant="danger">{loan.overdue_days} days</Badge>
                                          ) : (
                                            <span className="text-muted">On time</span>
                                          )}
                                        </td>
                                        <td className="py-3 text-right font-weight-bold" style={{ color: loan.fine_amount > 0 ? "#ef4444" : "#64748b" }}>
                                          {this.formatCurrency(loan.fine_amount)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            )}

                            {/* Section 2: Outstanding Fines */}
                            <h6 className="font-weight-bold mb-3 mt-4 text-dark d-flex align-items-center">
                              <i className="fal fa-file-invoice-dollar text-danger mr-2" /> Outstanding Fines & Fee Records
                            </h6>
                            {selectedStudentFines.filter(f => f.balance_amount > 0).length === 0 ? (
                              <Alert variant="success" className="d-flex align-items-center p-3 mb-0">
                                <i className="fal fa-info-circle fa-lg mr-3 text-success" />
                                <div style={{ fontSize: 13 }}>
                                  <strong>No pending library dues or fines.</strong>
                                </div>
                              </Alert>
                            ) : (
                              <div className="border rounded overflow-hidden shadow-xs">
                                <Table responsive hover className="mb-0" style={{ fontSize: 12 }}>
                                  <thead style={{ background: "#f8fafc" }}>
                                    <tr>
                                      <th className="py-2 px-3">Date</th>
                                      <th className="py-2">Book Title</th>
                                      <th className="py-2">Fine Reason</th>
                                      <th className="py-2 text-right">Fine Amt</th>
                                      <th className="py-2 text-right">Paid</th>
                                      <th className="py-2 text-right">Balance Due</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedStudentFines.filter(f => f.balance_amount > 0).map(fine => (
                                      <tr key={fine.id}>
                                        <td className="py-3 px-3 text-muted">{fine.created_at || "N/A"}</td>
                                        <td className="py-3 font-weight-bold text-dark">{fine.book_title}</td>
                                        <td className="py-3">
                                          <Badge variant="light" style={{ background: "#fee2e2", color: "#b91c1c", fontWeight: 700 }}>
                                            {fine.fine_type}
                                          </Badge>
                                        </td>
                                        <td className="py-3 text-right">{this.formatCurrency(fine.fine_amount)}</td>
                                        <td className="py-3 text-right text-success">{this.formatCurrency(fine.paid_amount)}</td>
                                        <td className="py-3 text-right font-weight-bold text-danger">
                                          {this.formatCurrency(fine.balance_amount)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            )}
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  )}
                </Col>
              </Row>
            )}
          </div>
        ) : (
          <div>
            {/* Report configuration filters */}
            <Row className="mb-4 align-items-end g-3">
              <Col md={3}>
                <Form.Group className="mb-0">
                  <Form.Label style={{ fontSize: 12, fontWeight: 700 }}>Report Type</Form.Label>
                  <Form.Control as="select" name="reportType" value={reportType} onChange={this.handleFieldChange} style={{ fontSize: 13, height: 38 }}>
                    {reportOptions.map((opt) => (
                      <option key={opt.key} value={opt.key}>{opt.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-0">
                  <Form.Label style={{ fontSize: 12, fontWeight: 700 }}>From Date</Form.Label>
                  <Form.Control type="date" name="startDate" value={startDate} onChange={this.handleDateChange} style={{ fontSize: 13, height: 38 }} />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group className="mb-0">
                  <Form.Label style={{ fontSize: 12, fontWeight: 700 }}>To Date</Form.Label>
                  <Form.Control type="date" name="endDate" value={endDate} onChange={this.handleDateChange} style={{ fontSize: 13, height: 38 }} />
                </Form.Group>
              </Col>
              <Col md={3} className="text-right">
                <Button
                  onClick={() => this.exportCSV(filteredReportData)}
                  disabled={filteredReportData.length === 0}
                  style={{
                    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    border: "none",
                    fontWeight: 700,
                    fontSize: 13,
                    width: "100%",
                    height: 38,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                >
                  <i className="fal fa-file-csv" /> Export Filtered CSV
                </Button>
              </Col>
            </Row>

            {/* Client-Side Sub-Filters */}
            {!loading && reportData.length > 0 && (
              <div className="p-3 mb-4 rounded bg-light border shadow-sm">
                <Row className="g-3 align-items-center">
                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#475569" }}>Search Borrower Name / Roll No / Details</Form.Label>
                      <Form.Control
                        type="text"
                        name="searchQuery"
                        value={searchQuery}
                        onChange={this.handleFieldChange}
                        placeholder="Search name or keywords..."
                        style={{ fontSize: 12, height: 36 }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#475569" }}>Filter by Class</Form.Label>
                      <CheckboxDropdown
                        placeholder="All Classes"
                        options={studentClassesOptions}
                        value={selectedClasses}
                        onChange={(vals) => this.setState({ selectedClasses: vals })}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-0">
                      <Form.Label style={{ fontSize: 11, fontWeight: 700, color: "#475569" }}>Filter by Section</Form.Label>
                      <CheckboxDropdown
                        placeholder="All Sections"
                        options={studentSectionsOptions}
                        value={selectedSections}
                        onChange={(vals) => this.setState({ selectedSections: vals })}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            )}

            {/* Report Content */}
            {loading ? (
              <div className="shimmer" style={{ height: 250, borderRadius: 12 }} />
            ) : error ? (
              <div className="p-4 text-center text-danger">Error: {error}</div>
            ) : paginatedReportData.length === 0 ? (
              <div className="text-center p-5 text-muted border rounded bg-white">
                <i className="fal fa-chart-bar fa-3x d-block mb-3 text-light" />
                <p>No records found matching filters.</p>
              </div>
            ) : (
              <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "hidden" }}>
                <Table responsive hover className="mb-0" style={{ fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: "#f8fafc", color: "#475569", borderBottom: "2px solid #e2e8f0" }}>
                      <th style={{ padding: "12px 20px" }}>Date</th>
                      <th>Activity Type</th>
                      <th>Details</th>
                      <th>Borrower</th>
                      <th>Class / Type</th>
                      <th className="text-center">Transaction Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedReportData.map((row) => (
                      <tr key={row.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                        <td style={{ padding: "14px 20px", color: "#64748b" }}>{row.date}</td>
                        <td>
                          <Badge variant="light" style={{ background: "#f1f5f9", color: "#475569", fontWeight: 700 }}>
                            {row.type}
                          </Badge>
                        </td>
                        <td style={{ fontWeight: 600, color: "#1f2937" }}>{row.description}</td>
                        <td>{row.student_name}</td>
                        <td>
                          {row.class_name && row.class_name !== "N/A" ? (
                            <span>
                              {row.class_name} 
                              {row.section_name && row.section_name !== "N/A" && ` (${row.section_name})`}
                            </span>
                          ) : (
                            <span className="text-muted">Staff</span>
                          )}
                        </td>
                        <td className="text-center" style={{ fontWeight: 700, color: row.amount > 0 ? "#ef4444" : "#64748b" }}>
                          {row.amount !== null ? this.formatCurrency(row.amount) : "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination Controls Dock */}
                <div className="d-flex justify-content-between align-items-center px-4 py-3 bg-light border-top" style={{ borderBottomLeftRadius: 12, borderBottomRightRadius: 12 }}>
                  <div className="text-muted" style={{ fontSize: 12 }}>
                    Showing <strong>{totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1}</strong> to <strong>{Math.min(currentPage * pageSize, totalCount)}</strong> of <strong>{totalCount}</strong> entries
                  </div>
                  
                  <div className="d-flex align-items-center" style={{ gap: 16 }}>
                    <Form.Control 
                      as="select" 
                      size="sm" 
                      value={pageSize} 
                      onChange={this.handlePageSizeChange} 
                      style={{ width: 100, fontSize: 12, height: 32, borderRadius: 6, border: "1.5px solid #e2e8f0" }}
                    >
                      <option value={10}>10 / page</option>
                      <option value={25}>25 / page</option>
                      <option value={50}>50 / page</option>
                      <option value={100}>100 / page</option>
                    </Form.Control>

                    <Pagination size="sm" className="mb-0">
                      <Pagination.First disabled={currentPage === 1} onClick={() => this.handlePageChange(1)} />
                      <Pagination.Prev disabled={currentPage === 1} onClick={() => this.handlePageChange(currentPage - 1)} />
                      {pageItems}
                      <Pagination.Next disabled={currentPage >= totalPages} onClick={() => this.handlePageChange(currentPage + 1)} />
                      <Pagination.Last disabled={currentPage >= totalPages} onClick={() => this.handlePageChange(totalPages)} />
                    </Pagination>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Reports;
